import {Component} from '@angular/core';

@Component({
    selector: 'app-pos-system',
    templateUrl: './pos-system.component.html',
    styleUrls: ['./pos-system.component.scss']
})
export class PosSystemComponent {
}
